import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Button, Row, Tooltip,Input, Form, Col, Pagination, Popconfirm, Collapse, Rate,Modal, notification} from 'antd';
import {Field, reduxForm} from "redux-form";
import TextField from '../formFields/TextField';
import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import jwtDecode from "jwt-decode";
import moment from 'jalali-moment';
import { CSVLink } from "react-csv";
import SelectFieldForLoadCity from "../formFields/SelectFieldForLoadCity";
import SelectFieldForLoadState from "../formFields/SelectFieldForLoadState";
import {API_FETCH} from './../../services/FetchService';
import "./styles.css";

const { TextArea } = Input;
const mobileValidation = value =>
value && !/^(?:0|98|\+98|\+980|0098|098|00980)?(9\d{9})$/i.test(value) ?
'تلفن همراه را صحیح وارد کنید.' : undefined

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        label: 'ردیف',
        key: 'key',
        width:'5%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        label: 'کد سیستمی',
        key: 'system_code',
        width:'10%',
        sorter: (a, b) => a.system_code - b.system_code,
    },
    {
        title: 'نام',
        dataIndex: 'name',
        label: 'نام',
        key: 'name',
    },
    {
        title: 'نام خانوادگی',
        dataIndex: 'family',
        label: 'نام خانوادگی',
        key: 'family',
        width:'10%',
    },
    {
        title: 'نوع کاربری',
        dataIndex: 'role',
        label: 'نوع کاربری',
        key: 'role',
        sorter: (a, b) => a.role.length - b.role.length
    },
    {
        title: 'موجودی (ریال)',
        dataIndex: 'balance',
        label: 'موجودی (ریال)',
        key: 'balance',
        sorter: (a, b) => a.balance.length - b.balance.length,
        className:"price"
    },
    {
        title: 'تعداد درخواست ها',
        dataIndex: 'order_count',
        label: 'تعداد درخواست ها',
        key: 'order_count',
        width:'8%',
        sorter: (a, b) => a.order_count - b.order_count,
    },
    {
        title: 'وضعیت',
        dataIndex: 'is_active',
        label: 'وضعیت',
        key: 'is_active',
    },
    {
        title: 'وضعیت پوز',
        dataIndex: 'pos',
        label: 'وضعیت پوز',
        key: 'pos',
        width:'6%',
    },
    {
        title: 'وضعیت تیکت',
        dataIndex: 'userTicket',
        label: 'وضعیت تیکت',
        key: 'userTicket',
    },
    {
        title: 'عملیات',
        dataIndex: 'action',
        label: 'عملیات',
        key: 'action',
        width:'30%'
    },
];

const header = [
    {
        label: 'ردیف',
        key: 'key'
    },
    {
        label: 'کد سیستمی',
        key: 'system_code',
    },
    {
        label: 'نام',
        key: 'name',
    },
    {
        label: 'نام خانوادگی',
        key: 'family',
    },
    {
        label: 'شماره ثابت',
        key: 'phone',
    },
    {
        label: 'شماره همراه',
        key: 'mobile',
    },
        {
        label: 'آدرس',
        key: 'address',
    },
];

const logsColumn = [
    {
        title: 'ردیف',
        dataIndex: 'key',
    },
    {
        title: 'نام و نام خانوادگی',
        dataIndex: 'fullName',
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
    },
    {
        title: 'توضیحات',
        dataIndex: 'operation_title',
    },
    {
        title: 'تاریخ',
        dataIndex: 'date',
    },
];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class List extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            roles:this.props.userValue ? this.props.userValue.rl : null,
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),//pagination
            expandedRowRender,
            filter:[],
            visible: true,
            message:'',
            usermobile:'',
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
        this.handleCancel()
    }

    componentDidMount() {
        let _ = require('lodash');
        this.props.getAreaList();
        this.props.getStateList();
        this.props.getCityList();
        this.handleCancel();
    }

    componentWillMount() {
        this.props.getList();
        this.props.getListForExcel({size:10});
        this.handleCancel()
        // this.props.getListForExcel({size:10000});
    }

    __getUserRole() {
        let role = this.state.roles

        if(!role){
            const userData = jwtDecode(this.props.userValue);
            role = userData.rl
        }

        switch (role) {
            case 'SUPERADMIN':
                return [
                    {label: "مدیر سایت", value: "ADMIN"},
                    {label: "تکنسین", value: "TECHNICIAN"},
                    {label: "اپراتور", value: "OPERATOR"},
                    {label: "مشتری", value: "CUSTOMER"}];

            case 'ADMIN':
                return [
                    {label: "تکنسین", value: "TECHNICIAN"},
                    {label: "اپراتور", value: "OPERATOR"},
                    {label: "مشتری", value: "CUSTOMER"}];

            case 'OPERATOR':
                return [
                    {label: "تکنسین", value: "TECHNICIAN"},
                    {label: "مشتری", value: "CUSTOMER"}];


            default:
                return '';

        }
    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        clearInterval(this.interval);
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    __translateUserticketTitle(type){
        switch (type) {
            case 'WERE_CONTACTED':
                return 'تماس گرفته شد.';
            case 'THEY_CHANGE_THEMSELVES':
                return 'خودشان تعویض می کنند.'
            case 'THEY_DID_NOT_ANSWER':
                return 'پاسخ ندادند.';
            case 'IT_IS_OFF':
                return 'خاموش بود.';
            case 'BLOCK_LIST':
                return 'بلاک لیست.';
            case 'THEY_CALL_THEMSELVES':
                return 'خودشان تماس میگیرند.';
            case 'RELUCTANCE_TO_RECEIVE_SERVICE':
                return 'عدم تمایل به دریافت سرویس.';
            case 'FREE_VISIT':
                return 'بازدید رایگان.';
            case 'MISCELLANEOUE':
                return 'متفرقه';
            case 'CALL_BACK':
                return 'تماس مجدد';
        }
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        var list = this.props.list;
        var dataSource = [];
        let role = '';
        let isAcrive;
        let userTicket;
        let extraInfo;
        let isActive;
        let pos;
        const { Panel } = Collapse;
        let stateList = []
        let cityList = []

        if(this.props.stateList)
            stateList = this.props.stateList.lists

        if(this.props.cityList)
            cityList = this.props.cityList.lists

        if(list && list.lists) {

            for (let i = 0; i < list.lists.length; i++) {
                let userTicketType="";
                let logs = [];
                let stateName;
                let cityName;

                if(list.lists[i].status_history && list.lists[i].status_history.length > 0) {
                    for (let j = 0; j < list.lists[i].status_history.length; j++) {
                        logs.push({
                            key: (j+1),
                            system_code: list.lists[i].status_history[j].system_code ? list.lists[i].status_history[j].system_code : '',
                            fullName: list.lists[i].status_history[j].fullname ? list.lists[i].status_history[j].fullname : '',
                            operation_title:list.lists[i].status_history[j].operation_title ? list.lists[i].status_history[j].operation_title : '',
                            date: list.lists[i].status_history[j].operation_date ? moment(list.lists[i].status_history[j].operation_date).format('jYYYY/jM/jD') : '',
                        });
                    }

                }


                switch (list.lists[i].role) {
                    case 'SUPERADMIN':
                        role = 'مدیر اصلی';
                        break;
                    case 'ADMIN':
                        role = 'مدیر سایت';
                        break;
                    case 'TECHNICIAN':
                        role = 'تکنسین';
                        break;
                    case 'OPERATOR':
                        role = 'اپراتور';
                        break;
                    case 'CUSTOMER':
                        role = 'مشتری';
                        break;

                }

                let addressList = [];
                {list.lists[i].addresses.map((addr,i) => {
                    addressList.push(<div key={i}><strong>{addr.tag} :</strong> {addr.text}</div>)
                })}

                if(list.lists[i])
                    extraInfo = <Collapse className="extraInfoWrapper">
                        <Panel header="اطلاعات بیشتر" key="1">
                            <Row className="collapseText">
                                {list.lists[i].mobile ?
                                    <div>
                                        <strong>شماره همراه : </strong>
                                        {list.lists[i].mobile}
                                    </div>
                                :null}
                                {list.lists[i].phone_number ?
                                    <div>
                                        <strong>شماره تلفن ثابت : </strong>
                                        {list.lists[i].phone_number}
                                    </div>
                                :null}
                                {list.lists[i].addresses ?
                                    <div>
                                        <strong>آدرس ها </strong>
                                        {addressList}
                                    </div>
                                :null}
                            </Row>
                        </Panel>
                        <Panel header="مشاهده سابقه" key="2">
                            {list.lists[i].status_history && list.lists[i].status_history.length > 0 ?
                                <Row className="collapseText">
                                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } pagination={false} columns={logsColumn} dataSource={logs} size="small" />
                                </Row>
                            :null}
                        </Panel>
                        <Panel header="تیکت مشتری" key="9">
                            {list.lists[i].userTicketsList ?
                                list.lists[i].userTicketsList.map((item,index)=>{
                                    return (
                                        <Row className="collapseText">
                                            <div>
                                                <strong>عنوان تیکت : </strong>
                                                {item.value ? this.__translateUserticketTitle(item.value) : null}
                                            </div>
                                            <div>
                                                <strong>توضیحات تیکت : </strong>
                                                {item.note ? item.note : null}
                                            </div>
                                            <div>
                                                <strong>زمان ایجاد : </strong>
                                                {item.created_at ? moment(item.created_at).format('jYYYY/jM/jD') : null}
                                            </div>
                                            <div>
                                                <strong>زمان تماس مجدد : </strong>
                                                {item.call_time ? moment(item.call_time).format('jYYYY/jM/jD') : null}
                                            </div>
                                            {
                                                item?.technician?
                                                    <div>
                                                        <strong>صادر کننده تیکت : </strong>
                                                        { item?.technician?.name+' '+item?.technician?.family}
                                                    </div>
                                                :null
                                            }
                                            <hr/>
                                        </Row>
                                    )
                                })
                            :null}
                        </Panel>
                    </Collapse>
                else
                    extraInfo = ''

                if(list.lists[i].is_active)
                    isActive = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i} />
                else
                    isActive = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96"  key={i} />

                if(list.lists[i].userTicket){
                    if(list.lists[i].userTicket?.value==="BLOCK_LIST"){
                        userTicketType='BLOCK_LIST'
                    }
                    userTicket = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i} />
                } else {
                    userTicket = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96"  key={i} />
                }

                if(list.lists[i].role === 'TECHNICIAN') {
                    if (list.lists[i].pos != null)
                        pos = <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" key={i}/>
                    else
                        pos = <Icon type="close-circle" theme="twoTone" twoToneColor="#eb2f96" key={i}/>
                }else
                    pos = '';

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    name: list.lists[i].name,
                    family: list.lists[i].family,
                    role: role,
                    mobile: list.lists[i].mobile,
                    balance: (list.lists[i].balance).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                    order_count: list.lists[i].order_count,
                    is_active: isActive,
                    userTicketType:userTicketType,
                    userTicket:userTicket,
                    pos: pos,
                    extraInfo: extraInfo,
                    action: <span>
                                <Tooltip placement="top" title="ارسال پیام">
                                    <span className="purpleListBtn"><Icon type="mail" onClick={(e) => this.showModal(list.lists[i].mobile)}/></span>
                                </Tooltip>
                                <Divider type="vertical" />
                                <Tooltip placement="top" title="ویرایش">
                                    <a href={"#/user/edit/"+list.lists[i]._id} className="listBtn"><Icon type="edit" /></a>
                                </Tooltip>
                                <Divider type="vertical" />
                                {(list.lists[i].role === 'OPERATOR' ?
                                <Tooltip placement="top" title="سطح دسترسی">
                                    <a href={"#/user/permissions/"+list.lists[i]._id} className="redListBtn"><Icon type="unlock" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'OPERATOR' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Tooltip placement="top" title="انتخاب دستگاه پوز">
                                    <a href={"#/pos/"+list.lists[i]._id} className="greenListBtn2"><Icon type="diff" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Divider type="vertical" />
                                : null)}
                                {((list.lists[i].role === 'TECHNICIAN' || list.lists[i].role === 'CUSTOMER') ?
                                <Tooltip placement="top" title="ایجاد تراکنش">
                                    <a href={"#/transaction/add/"+list.lists[i]._id} className="blueListBtn"><Icon type="plus" /></a>
                                </Tooltip>
                                : null)}
                                {((list.lists[i].role === 'TECHNICIAN' || list.lists[i].role === 'CUSTOMER') ?
                                <Divider type="vertical" />
                                : null)}
                                {((list.lists[i].role === 'TECHNICIAN' || list.lists[i].role === 'CUSTOMER') ?
                                <Tooltip placement="top" title="مشاهده تراکنش ها">
                                    <a href={"#/transaction/list/"+list.lists[i]._id} className="grayListBtn"><Icon type="transaction" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'CUSTOMER' || list.lists[i].role === 'TECHNICIAN' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Tooltip placement="top" title="مشاهده درخواست ها">
                                    <a href={"#/order/list/technician/"+list.lists[i]._id} className="greenListBtn2"><Icon type="unordered-list" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'CUSTOMER' ?
                                    <Tooltip placement="top" title="مشاهده درخواست ها">
                                        <a href={"#/order/list/customer/"+list.lists[i]._id} className="greenListBtn2"><Icon type="unordered-list" /></a>
                                    </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' || list.lists[i].role === 'CUSTOMER' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'CUSTOMER' ?
                                    <Tooltip placement="top" title="ایجاد درخواست">
                                        <a href={"#/order/add/"+list.lists[i].mobile+"/"+list.lists[i]._id} className="greenListBtn2"><Icon type="plus" /></a>
                                    </Tooltip>
                                    : null)}
                                {(list.lists[i].role === 'CUSTOMER' ?
                                    <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Tooltip placement="top" title="گزارش انبار">
                                    <a href={"#/warehouse/technician/"+list.lists[i]._id} className="purpleListBtn"><Icon type="unordered-list" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Tooltip placement="top" title="گزارش موجودی انبار">
                                    <a href={"#/warehouse/technician/"+list.lists[i]._id+"/inventory"} className="purpleListBtn"><Icon type="ordered-list" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Tooltip placement="top" title="تسویه تکنسین">
                                    <a href={"#/user/settle/"+list.lists[i]._id} className="greenListBtn"><Icon type="dollar-circle" theme="filled" /></a>
                                </Tooltip>
                                : null)}
                                {(list.lists[i].role === 'TECHNICIAN' ?
                                <Divider type="vertical" />
                                : null)}
                                {(list.lists[i].role === 'CUSTOMER' ?
                                <Tooltip placement="top" title="اطلاعات بیشتر مشتری">
                                    <a href={"#/user/comment/"+list.lists[i]._id} className="purpleListBtn"><Icon type="wechat" /></a>
                                </Tooltip>
                                : null)}

                            </span>
                });
            }
        }
        return dataSource;
    }

    __fixListForShowInExcel() {

        var list = this.props.list;
        var dataSource = [];
        let role = '';
        let isActive;
        let userTicket;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {

                let addressList = [];
                {list.lists[i].addresses.map((addr,i) => {
                    addressList.push(<div key={i}><strong>{addr.tag} :</strong> {addr.text}</div>)
                })}

                dataSource.push(
                    {
                        key: i+1,
                        system_code: list.lists[i].system_code,
                        name: list.lists[i].name,
                        family: list.lists[i].family,
                        phone: list.lists[i].phone_number,
                        mobile: list.lists[i].mobile,
                        address: addressList,
                        // role: role,
                        // balance: (list.lists[i].balance).toLocaleString(navigator.language, { minimumFractionDigits: 0 }),
                        // order_count: list.lists[i].order_count,
                        // is_active: isActive,
                        // userTicket:userTicket
                    }
                );
            }
        }
        return dataSource;
    }

    confirm(orderId) {
        this.props.cancelOrder(orderId)
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        this.props.handleSubmit(value);
        if(this.state.mobile)
            this.setState(prevState  => ({
                filter: { ...prevState.filter,mobile:this.state.mobile}
            }))
        if(this.state.phone_number)
            this.setState(prevState  => ({
                filter: { ...prevState.filter,phone_number:this.state.phone_number}
            }))
        if(this.state.role)
            this.setState(prevState  => ({
                filter: {...prevState.filter,role:this.state.role}
            }))
        if(this.state.system_code)
            this.setState(prevState  => ({
                filter: {...prevState.filter,system_code:this.state.system_code}
            }))
        if(this.state.name)
            this.setState(prevState  => ({
                filter: {...prevState.filter,name:this.state.name}
            }))
        if(this.state.family)
            this.setState(prevState  => ({
                filter: {...prevState.filter,family:this.state.family}
            }))
        if(this.state.username)
            this.setState(prevState  => ({
                filter: {...prevState.filter,username:this.state.username}
            }))
        if(this.state.stateId)
            this.setState(prevState  => ({
                filter: {...prevState.filter,state:this.state.stateId}
            }))
        if(this.state.city)
            this.setState(prevState  => ({
                filter: {...prevState.filter,city:this.state.city}
            }))
    }

    async __onChangeCounter(current, pageSize) {
        clearInterval(this.interval);
        this.setState({size:pageSize});
        this.setState({pageSize:pageSize})
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        this.props.getList();
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    __getAreaStateList() {
        let areaList = this.props.areaList;
        let dataSource = [];

        if (areaList) {

            for (let i = 0; i < areaList.length; i++) {

                dataSource.push(
                    {label: areaList[i].title, value: areaList[i]._id, key: i,cities:areaList[i].cities}
                );

            }

        }
        return dataSource;
    }

    __fixCitiesObject(list) {
        let dataSource = [];
        if (list) {
            for (let i = 0; i < list.length; i++) {
                dataSource.push(
                    {label: list[i].title, value: list[i]._id, key: i}
                );
            }
        }
        return dataSource;
    }

    showModal = (mob) => {
        this.setState({
          visible: true,
          usermobile:mob
        });
    };

    handleOk = e => {
            API_FETCH.post('user/send-sms', {user:this.state.usermobile,message:this.state.message}).then(response => {
                if(response.status === 200) {
                    notification.open({
                      duration: 3,
                      message: 'پیام سیستمی',
                      description: 'عملیات شما با موفقیت انجام شد',
                      icon: <Icon type={'smile'} theme="twoTone" twoToneColor={'#52c41a'} style={{ color: '#108ee9', fontSize: '36px' }} />,
                    });
                } else {
                    notification.open({
                        duration: 3,
                        message: 'پیام سیستمی',
                        description: 'خطا در ایجاد',
                        icon: <Icon type={'smile'} theme="twoTone" twoToneColor={'#e51616'} style={{ color: '#108ee9', fontSize: '36px' }} />,
                    });
                }
            }).catch(error => {
                notification.open({
                    duration: 3,
                    message: 'پیام سیستمی',
                    description: 'خطا در ایجاد',
                    icon: <Icon type={'smile'} theme="twoTone" twoToneColor={'#e51616'} style={{ color: '#108ee9', fontSize: '36px' }} />,
                });
            });

            this.setState({
                visible: false,
                message:'',
                usermobile:'',
            });
    };
    
    handleCancel = e => {
      this.setState({
        visible: false,
        message:'',
        usermobile:'',
      });
    };

    onChangeMessage = ({ target: { value } }) => {
      this.setState({ message:value });
    };

    render() {
        var _self = this;
        const { searchBoxHidden,pageSize,message } = this.state;
        const { list } = this.props;

        /* ----- Get List of state -----*/
        var stateList = this.__getAreaStateList();
        var cityList = [];
    
        if(this.state.stateId)
        {
            for(let i  = 0;i< stateList.length ; i++)
            {
                if (stateList[i]['value'] == this.state.stateId)
                {
                    cityList = stateList[i]['cities'];
                    cityList = _self.__fixCitiesObject(cityList); //-- fix city object for Selecbox field
                }
            }
        }

        var data = this.__fixListForShowInExcel()
        return (
            <>
                <div>
                <Row type="flex">
                    <RTLCol xs={24} md={17}>
                        <Divider orientation="left">لیست کاربران</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={7} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                        {
                            data.length > 0 ?
                                <RTLButton type="primary" className="userListBtn" shape="round" >
                                    <CSVLink
                                        data={data}
                                        headers={header}
                                        className='export-link'
                                        filename={"user_list.csv"}
                                        target="_blank"
                                    >
                                        خروجی اکسل
                                    </CSVLink>
                                </RTLButton>
                            : null
                        }
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="plus" href="#/user/add">
                            ایجاد کاربر
                        </RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={3}>
                                <Field
                                    min="0"
                                    validate={mobileValidation}
                                    name="mobile"
                                    component={TextField}
                                    type="number"
                                    maxLength={11}
                                    placeholder="شماره همراه"
                                    onBlur={(mobile) => this.setState({mobile:mobile.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={3}>
                                <Field
                                    min="0"
                                    // validate={mobileValidation}
                                    name="phone_number"
                                    component={TextField}
                                    type="number"
                                    maxLength={11}
                                    placeholder="شماره ثابت"
                                    onBlur={(phone_number) => this.setState({phone_number:phone_number.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={3}>
                                <Field
                                    name="system_code"
                                    component={TextField}
                                    type="text"
                                    placeholder="کد سیستمی"
                                    onBlur={(system_code) => this.setState({system_code:system_code.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={3}>
                                <Field
                                    name="name"
                                    component={TextField}
                                    type="text"
                                    placeholder="نام"
                                    onBlur={(name) => this.setState({name:name.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={3}>
                                <Field
                                    name="family"
                                    component={TextField}
                                    type="text"
                                    placeholder="نام خانوادگی"
                                    onBlur={(family) => this.setState({family:family.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="username"
                                    component={TextField}
                                    type="text"
                                    placeholder="نام کاربری"
                                    onBlur={(username) => this.setState({username:username.target.value})}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="state"
                                    component={SelectFieldForLoadState}
                                    placeholder="استان"
                                    list={stateList}
                                    onChangeVal={(stateId) => {
                                        _self.setState({stateId : stateId})
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,stateId:stateId}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="city"
                                    component={SelectFieldForLoadCity}
                                    placeholder="شهر"
                                    list={cityList}
                                    onChange={(city) => {
                                        this.setState(prevState  => ({
                                            filter: {...prevState.filter,city:city}
                                        }))
                                    }}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={4}>
                                <Field
                                    name="role"
                                    component={SelectField}
                                    placeholder="نوع کاربری"
                                    list={this.__getUserRole()}
                                    onChange={(role) => this.setState({role:role})}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                 <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => record?.userTicketType=="BLOCK_LIST"? 'table-row-red':(index+1)%2 == 0 ? 'even' : 'odd'} {...this.state} pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : this.state.size)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions={['10', '20','30','40','50','60','70','80','90','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
                </div>

                <Modal title="ارسال پیام"
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                    onOk={this.handleOk}
                >
                    <TextArea rows={4} placeholder='پیام مورد نظر را بنویسید ...' value={message} onChange={this.onChangeMessage}/>
                </Modal>
            </>
        );
    }
}

export default List = reduxForm({
    form: 'search'
})(List)
